export class RestartFailError extends Error {
  constructor(message?: string) {
    super(message);

    this.name = 'RestartFailError';
  }
}
